<div class="privacy-policy-wrapper">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <h1>Privacy Policy</h1>
  <p><strong>Effective Date:</strong> 4/3/2025</p>

  <p>
    HTML Arcade (“Company,” “we,” “us,” or “our”) is committed to safeguarding your privacy. This Privacy Policy explains in exhaustive detail how we collect, use, store, disclose, and secure your information. It applies to all users (“Users”) of the HTML Arcade Platform, encompassing all associated services, websites, and games (collectively, the “Platform”).
  </p>

  <p>
    By accessing or using the Platform, you signify your understanding and acceptance of this Privacy Policy. If you do not agree with any portion of this policy, you are required to discontinue use of the Platform immediately.
  </p>

  <h2>1. Scope and Application</h2>
  <h3>1.1 Scope</h3>
  <ul>
    <li>Individuals who browse our website.</li>
    <li>Registered users engaging with games or purchasing virtual Points or Coins.</li>
    <li>Visitors contacting us via customer support.</li>
  </ul>
  <h3>1.2 Third-Party Exclusion</h3>
  <ul>
    <li>Services, websites, or platforms linked to from our Platform but operated by third parties.</li>
    <li>Information handled directly by third-party payment processors during financial transactions.</li>
  </ul>
  <h3>1.3 Regulatory Considerations</h3>
  <p>
    We comply with global privacy laws, including but not limited to the GDPR, CCPA, and others. Specific user rights under these laws are detailed in Section 7.
  </p>

  <h2>2. Information We Collect</h2>
  <h3>2.1 Information You Provide Directly</h3>
  <ul>
    <li>Full legal name, email, DOB, username, password</li>
    <li>Billing address, transaction IDs, order details</li>
    <li>Support communications and shared data</li>
  </ul>
  <h3>2.2 Information Collected Automatically</h3>
  <ul>
    <li>Device identifiers, IP address, browser, OS, language</li>
    <li>Gameplay statistics, activity logs, session data</li>
    <li>Geolocation based on IP/device settings</li>
  </ul>
  <h3>2.3 Cookies and Similar Technologies</h3>
  <ul>
    <li>Authentication, session security</li>
    <li>User behavior analytics</li>
    <li>Personalized content and ads</li>
  </ul>

  <h2>3. How We Use Your Information</h2>
  <ul>
    <li>To enable access and features of the Platform</li>
    <li>To process purchases and deliver in-game content</li>
    <li>To offer tailored recommendations and support</li>
    <li>To comply with legal obligations</li>
    <li>To send updates and promotional content (opt-in only)</li>
  </ul>

  <h2>4. Sharing and Disclosure of Information</h2>
  <ul>
    <li>Trusted vendors for payments, storage, analytics</li>
    <li>In M&A scenarios, with notice and protections</li>
    <li>To comply with law enforcement or legal obligations</li>
    <li>With partners, in anonymized/de-identified form</li>
  </ul>

  <h2>5. Data Security</h2>
  <ul>
    <li>Encryption (AES-256, TLS), access controls, monitoring</li>
    <li>We notify users within 72h of any confirmed breach</li>
  </ul>

  <h2>6. Retention of Information</h2>
  <ul>
    <li>Data is retained only as long as necessary</li>
    <li>Old or inactive data may be deleted or anonymized</li>
  </ul>

  <h2>7. User Rights and Choices</h2>
  <ul>
    <li>Access, correct, delete, or restrict processing</li>
    <li>Port data upon request</li>
    <li>Email support&#64;htmlarcade.com to exercise rights</li>
  </ul>

  <h2>8. International Data Transfers</h2>
  <p>
    Data may be transferred internationally under strict protections such as SCCs or compliance frameworks.
  </p>

  <h2>9. Children’s Privacy</h2>
  <p>
    Our Platform is not intended for users under 18. We delete data from minors as soon as detected.
  </p>

  <h2>10. Changes to This Privacy Policy</h2>
  <p>
    We may update this policy. Material changes will be announced via email or in-app notice. Last updated date is always listed.
  </p>

  <h2>11. Contact Information</h2>
  <p>
    Email: <a href="mailto:sibi@sibicba.com">sibi&#64;sibicba.com</a><br />
    Mailing Address: 5132 Topping Lane, Glen Allen, VA 23060
  </p>
</div>
